import { Box, Text } from '@wix/design-system';
import { ShareFeedbackSection } from '@wix/wix-help-widget-common/homepage';
import { useTranslation } from '@wix/wix-i18n-config';
import { ChevronRight, InfoCircle } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';
import { useStore } from 'react-redux';

import { homepageSlice } from '../../../common/reducers/homepage';
import { IMetaUpdateDealerOfferParams } from '../../../common/reducers/types';
import { ACTIONS } from '../../../constants';
import { TLocalesKeys } from '../../../types';
import { biHelpCenter } from '../../../util/bi';
import { emitter } from '../../../util/emitter';
import s from '../styles.scss';
import { SectionComponentProps } from '../types';
import { shareFeedbackDataHooks } from './ShareFeedback.dataHooks';

export const ShareFeedback: FC<SectionComponentProps<ShareFeedbackSection>> = ({
  positionIndex,
}) => {
  const store = useStore();
  const { t } = useTranslation();

  const buttonText = t<TLocalesKeys>('report_a_bug');

  const navigateToReportABugFlow = useCallback(() => {
    biHelpCenter.logReportABugInteraction({ positionIndex, text: buttonText });
    const reportABugNodeId = '3pUxTPI5Tg6qopSZBbIi';

    store.dispatch(homepageSlice.actions.reportABugFlowStarted(true));

    store.dispatch<IMetaUpdateDealerOfferParams>({
      type: ACTIONS.META_UPDATE_DEALER_OFFER_PARAMS,
      dealerOfferParams: new Map([['nodeId', reportABugNodeId]]),
    });
    emitter.emit('toggleChatbotVisible', true);
  }, []);

  return (
    <div
      className={s.homepageActionItem}
      onClick={navigateToReportABugFlow}
      data-hook={shareFeedbackDataHooks.container()}
    >
      <Box
        verticalAlign="middle"
        gap={2}
        padding="12px 6px 12px 12px"
        cursor="pointer"
        width="100%"
      >
        <Box color="B10">
          <InfoCircle />
        </Box>
        <Box direction="vertical" flexGrow={1}>
          <Text size="small" secondary>
            {buttonText}
          </Text>
        </Box>
        <ChevronRight className={s.svgIcon} size="24" />
      </Box>
    </div>
  );
};
